/**
 * Qué decirle a la persona cuando una llamada falla — sin React (se prueba con Jest).
 *
 * El 24/10 el panel del técnico decía «No se pudieron cargar las personas de la campaña» para TRES
 * cosas distintas: no ser técnico de la campaña (403), un backend que aún no tenía la ruta (404, lo
 * que pasó de verdad: el proceso llevaba un día sin reiniciar) y un fallo real (500, red). Con el
 * mismo mensaje no había forma de saber cuál era. Cada uno dice ya lo suyo.
 *
 * `textos`: { prohibido, generico } — lo propio de cada pantalla.
 */
export function mensajeDeError(error, { prohibido = 'No tienes permiso para ver esto.', generico = 'No se ha podido cargar.' } = {}) {
  const status = error && error.response ? error.response.status : null;
  const cuerpo = (error && error.response && error.response.data) || {};
  if (status === 403) return { tipo: 'prohibido', texto: prohibido };
  if (status === 404 && typeof cuerpo === 'string' && /Cannot (GET|POST|PUT|PATCH|DELETE)/.test(cuerpo)) {
    // El 404 de Express —no un «no existe esa campaña» de la API, que viene en JSON—.
    return { tipo: 'sin_ruta', texto: 'El servidor no tiene esta función. Puede que el backend no esté actualizado: avisa a Sistemas.' };
  }
  if (status && status < 500 && cuerpo && typeof cuerpo === 'object' && cuerpo.error) {
    return { tipo: 'rechazo', texto: cuerpo.error };
  }
  return { tipo: 'fallo', texto: `${generico} Vuelve a intentarlo; si sigue, avisa a Sistemas.` };
}
